/**
 * Archivo: SegundaCabecera.js
 * Autor: Acher Egido Mairal
 * Fecha de última modificación: 20/08/2024
 * 
 * Descripción:
 * Este componente define una cabecera secundaria para la navegación en la aplicación, mostrando botones de navegación 
 * y una sección de notificaciones con un contador de mensajes nuevos.
 * 
 * Dependencias:
 * - react: ^18.2.0
 * - react-router-dom: ^6.0.2
 * - js-cookie: ^3.0.1
 * - MensajesServicios: Servicio para obtener el conteo de mensajes nuevos.
 * 
 * Propósito:
 * Proporcionar una interfaz de navegación secundaria con botones dinámicos que cambian su estado basado en la ruta actual 
 * y mostrar un contador de mensajes nuevos.
 */

import { useNavigate, useLocation } from 'react-router-dom';
import React, { useState, useEffect } from 'react';
import Cookies from 'js-cookie';
import { getMensajesNuevos } from '../Servicios/MensajesServicios';
import notificacionesBlanco from '../Imagenes/Iconos/NotificacionesBlanco.png';
import ajustesBlanco from '../Imagenes/Iconos/AjustesBlanco.png';

const SegundaCabecera = ({ hayVentanas, permisos }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const [mensajesNuevos, setMensajesNuevos] = useState(0);

    useEffect(() => {
        const fetchData = async () => {
            const token = Cookies.get('token');
            const result = await getMensajesNuevos(token);
            if (result.success) {
                setMensajesNuevos(result.data);
            }
        };
        fetchData();
    }, []);

    const irOrlaColegial = () => {
        navigate(process.env.PUBLIC_URL + '/OrlaColegial');
    };
    const irBoletines = () => {
        navigate(process.env.PUBLIC_URL + '/Boletines');
    };
    const irComunicados = () => {
        navigate(process.env.PUBLIC_URL + '/ComunicadosOficiales');
    };
    const irMenusComedor = () => {
        navigate(process.env.PUBLIC_URL + '/MenusComedor');
    };
    const irPasesComidas = () => {
        navigate(process.env.PUBLIC_URL + '/PaseComidas');
    };
    const irUsuarios = () => {
        navigate(process.env.PUBLIC_URL + '/UsuariosAdmin');
    };
    const irMensajeria = () => {
        navigate(process.env.PUBLIC_URL + '/Mensajeria');
    };
    const irNotificaciones = () => {
        navigate(process.env.PUBLIC_URL + '/Notificaciones');
    };
    const irAjustes = () => {
        navigate(process.env.PUBLIC_URL + '/AjustesAdmin');
    };

    return (
        <div className="row-fluid" style={{ opacity: hayVentanas ? 0.4 : 1 }}>
            <div className="container-fluid d-flex align-items-center justify-content-between navbar">
                <button className={`col-2 btn customBotonCabecera ${location.pathname.includes('/OrlaColegial') ? 'active' : ''}`} type="button" onClick={irOrlaColegial}> Orla colegial</button>
                <button className={`col-2 btn customBotonCabecera ${location.pathname.includes('/Boletines') ? 'active' : ''}`} type="button" onClick={irBoletines}> Boletín semanal</button>
                <button className={`col-2 btn customBotonCabecera ${location.pathname.includes('/MenusComedor') ? 'active' : ''}`} type="button" onClick={irMenusComedor}> Menú comedor </button>
                <button className={`col-${permisos === 'Administrador' ? '2' : '3'} btn customBotonCabecera ${location.pathname.includes('/ComunicadosOficiales') ? 'active' : ''}`} type="button" onClick={irComunicados}> Comunicados oficiales </button>
                {permisos === "Colegial" &&
                    <button className={`col-2 btn customBotonCabecera ${location.pathname.includes('/PaseComidas') ? 'active' : ''}`} type="button" onClick={irPasesComidas}> Pase de comidas </button>
                }
                {permisos === "Conserjería" &&
                    <button className={`col-2 btn customBotonCabecera ${location.pathname.includes('/Mensajeria') ? 'active' : ''}`} type="button" onClick={irMensajeria}> Mensajería </button>
                }
                {permisos === "Administrador" &&
                    <>
                        <button className={`col-2 btn customBotonCabecera ${location.pathname.includes('/UsuariosAdmin') ? 'active' : ''}`} type="button" onClick={irUsuarios}> Usuarios </button>
                        <div className={`col-1 btn customBotonCabecera d-flex justify-content-center position-relative ${location.pathname.includes('/Ajustes') ? 'active' : ''}`} onClick={irAjustes}>
                            <img
                                alt="ajustes"
                                className="img mt-0"
                                src={ajustesBlanco}
                                style={{ height: '2.2rem', width: '2.2rem', cursor: 'pointer' }}
                            />
                        </div>
                    </>
                }
                <div className={`col-1 btn customBotonCabecera d-flex justify-content-center position-relative ${location.pathname.includes('/Notificaciones') ? 'active' : ''}`} onClick={irNotificaciones}>
                    <img
                        alt="notificaciones"
                        className="img mt-0"
                        src={notificacionesBlanco}
                        style={{ height: '2.2rem', width: '2.2rem', cursor: 'pointer' }}
                    />
                    {mensajesNuevos > 0 && (
                        <span className="badge badge-danger position-absolute" style={{ top: 0, right: 0 }}>
                            {mensajesNuevos}
                        </span>
                    )}
                </div>
            </div>
        </div>
    );
};

export default SegundaCabecera;
